class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.el = document.querySelector("[data-predictive-search]");
    this.input = this.el.querySelector('input[type="search"]');
    this.resultsContainer = document.querySelector("[data-results-container]");
    this.status = document.getElementById("PredictiveSearchStatus");
    this.input.addEventListener("input", (e) => {
      const term = e.target.value.trim();
      if (!term.length) {
        this.resultsContainer.innerHTML = "";
        this.announce("");
        return;
      }
      this.getResults();
    });
  }

  // Announce the result count to assistive tech. Writes only to the live
  // region; the visual results container is left untouched.
  announce(term) {
    if (!this.status) return;

    if (!term.length) {
      this.status.textContent = "";
      return;
    }

    const count =
      this.resultsContainer.querySelectorAll(".results-item").length;

    this.status.textContent =
      count === 0
        ? `No results found for ${term}`
        : `${count} ${count === 1 ? "result" : "results"} found for ${term}`;
  }

  getResults() {
    setTimeout(async () => {
      if (this.input.value === "") {
        this.resultsContainer.innerHTML = "";
        this.announce("");
      } else {
        try {
          const res =
            await fetch(`/search/suggest?q=${this.input.value}&resources[type]=query,article,product,page&resources[options]
          [unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku&section_id=predictive-search`);
          const text = await res.text();

          this.resultsContainer.innerHTML = text;

          this.resultsContainer
            .querySelectorAll("[data-query]")
            .forEach((button) => {
              const query = button.getAttribute("data-query");
              button.addEventListener("click", () => {
                this.input.value = query;
                this.getResults(query);
              });
            });

          // The results template only emits #predictive-search-results when a
          // search was performed, so this can legitimately be absent.
          const resultsPanel = this.resultsContainer.querySelector(
            "#predictive-search-results",
          );
          if (resultsPanel && resultsPanel.innerHTML.trim() === "") {
            resultsPanel.innerHTML = "No Results";
          }

          this.announce(this.input.value.trim());
        } catch (err) {
          console.log(err);
        }
      }
    }, 500);
  }
}

customElements.define("predictive-search", PredictiveSearch);
